import { ICommandShortcutHandlerProvider, ICommandShortcutHandler } from '@/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface';
import { commandShortcutHandlerTypes } from '@/components/chat/_domain/modules/command-shortcut-service/handlers';
import { injectable } from 'inversify';

@injectable()
class CommandShortcutHandlerProvider implements ICommandShortcutHandlerProvider {
  private readonly commandShortcutHandlers: ICommandShortcutHandler[] = [];

  constructor() {
    this.initialiseCommandShortcutHandlers();
  }

  public getAllHandlers(): ICommandShortcutHandler[] {
    return this.commandShortcutHandlers;
  }

  private initialiseCommandShortcutHandlers() {
    Object.keys(commandShortcutHandlerTypes).forEach(this.initialiseCommandShortcutHandler, this);
  }

  private initialiseCommandShortcutHandler(commandShortcutHandlerTypeName: string): void {
    const commandShortcutHandlerType = commandShortcutHandlerTypes[commandShortcutHandlerTypeName];
    const commandShortcutHandlerInstance = this.getCommandShortcutHandlerInstance(commandShortcutHandlerType);
    this.addCommandShortcutHandler(commandShortcutHandlerInstance);
  }

  private getCommandShortcutHandlerInstance(commandShortcutHandlerType: new() => ICommandShortcutHandler): ICommandShortcutHandler {
    return new commandShortcutHandlerType();
  }

  private addCommandShortcutHandler(commandShortcutHandler: ICommandShortcutHandler): void {
    this.commandShortcutHandlers.push(commandShortcutHandler);
  }
}

export { CommandShortcutHandlerProvider };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/command-shortcut-handler-provider.ts